export default "__VITE_ASSET__CckVB1ob__"